import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEdit, faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { SectionMode, ActionState } from "../../Default/common/section"
library.add(faEdit, faAngleDoubleDown)
Vue.component('font-awesome-icon', FontAwesomeIcon)


@Component({
})

export default class NewContractSection extends Vue {
    @Prop()
    title: string;

    @Prop()
    number: number;

    @Prop({ default: SectionMode.Edit })
    mode: SectionMode;

    @Prop({ default: ActionState.Enabled })
    proceedActionState: ActionState;

    @Emit()
    modify() {}

    @Emit()
    proceed() {}

    SectionMode: typeof SectionMode = SectionMode;
    ActionState: typeof ActionState = ActionState;

    constructor() {
        super();
    }

    mounted() {
    }

    titleToString(): string {
        //const title = this.$i18n.tc(this.title);
        return this.title;
    }

    get showEdit() {
        return this.mode == SectionMode.Edit;
    }
    set showEdit(value: any) {
        
    }

    get showDisplay() {
        return this.mode == SectionMode.Display;
    }
    set showDisplay(value: any) {

    }

    iD(num: string): string {
        return "collapse" + num + "-" + this.number;
    }
}